
import { Component, Prop, Vue } from "vue-property-decorator"
import { CircularLoader, PullRefresh } from "@coredination/components"
import UnderConstruction from "@/components/misc/UnderConstruction.vue"

import OrderDetailQuery from "@/graphql/order/orderdetail.graphql"

@Component({
    components: { UnderConstruction, CircularLoader, PullRefresh },
    apollo: {
        order: {
            query: OrderDetailQuery,
            skip() {
                return !this.uuid
            },
            variables() {
                return { uuid: this.uuid }
            },
        },
    },
})
export default class OrderForm extends Vue {
    @Prop()
    uuid?: string

    order: any = {}
    refreshing = false
    get loading() {
        return this.refreshing || (this.$apollo.loading && !this.order.title)
    }

    async refresh() {
        this.refreshing = true
        await this.$apollo.queries.order.refetch()
        this.refreshing = false
    }
}
